import { render, staticRenderFns } from "./d4.vue?vue&type=template&id=64566322&scoped=true"
import script from "./d4.vue?vue&type=script&lang=js"
export * from "./d4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64566322",
  null
  
)

export default component.exports